/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Nav_Load_Folder_Structure_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to load folder structure" |
*
* @param {Explorer_Nav_Load_Folder_Structure_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_nav_load_folder_structure_failed_toast = /** @type {((inputs?: Explorer_Nav_Load_Folder_Structure_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Nav_Load_Folder_Structure_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Echec du chargement de la structure des dossiers")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ordnerstruktur konnte nicht geladen werden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile caricare la struttura delle cartelle")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось загрузить структуру папок.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo cargar la estructura de la carpeta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("加载文件夹结构失败")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フォルダ構造の読み込みに失敗しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ोल्डर संरचना लोड करने में विफल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Falha ao carregar a estrutura de pastas")
	return /** @type {LocalizedString} */ ("Failed to load folder structure")
});